import { alpha } from '@mui/material';
import { getBlendColors } from 'hooks/useDesign';

const MI_COLORS = {
    blue: '#075B7E',
    black: '#222222',
    green: '#077E45',
    red: '#AC2B2B',
    orange: '#FFB000',
    yellow: '#FFE65A',
    white: '#FFFFFF',
};
export const designOptions = {
    breakpoints: {
        values: {
            xs: 0,
            sm: 552, //600
            md: 900,
            lg: 1128, //1200
            xl: 1536,
            popupSm: 408,
            popupMd: 600,
            popupLg: 792,
            popupXl: 1176,
        },
    },
    palette: {
        mode: 'light',
        text: {
            primary: MI_COLORS.black,
            secondary: getBlendColors({} as any, alpha(MI_COLORS.black, 0.64), MI_COLORS.white), //Need to refactor (remove or set by opacity)
            disabled: getBlendColors({} as any, alpha(MI_COLORS.black, 0.12), MI_COLORS.white), //'#E4E4E4' Need to refactor (remove or set by opacity)
            opposite: '#fff', //on color background
        },
        primary: {
            main: MI_COLORS.blue, //Old #37809F
            contrastText: '#fff',
        },
        error: {
            main: MI_COLORS.red, //Old CF5548
            contrastText: '#fff',
        },
        warning: {
            main: MI_COLORS.orange,
            contrastText: '#fff',
        },
        success: {
            main: MI_COLORS.green, //Old #60A177
            contrastText: '#fff',
        },
        warningLow: {
            main: MI_COLORS.yellow,
            contrastText: '#222',
        },
        neutral: {
            //review usage
            main: '#666666',
            contrastText: '#ffffff',
        },
        divider: getBlendColors({} as any, alpha(MI_COLORS.black, 0.08), MI_COLORS.white), //Need to refactor (remove or set by main.text)
        background: {
            default: MI_COLORS.white,
        },
    },
    spacing: 8,
    shape: {
        borderRadius: 3,
    },
    font: {
        default: 'Inter, Arial, Helvetica, sans-serif',
        monospace: '"JetBrains Mono", monospace',
    },
    size: {
        pxValue: (px: number) => px + 'px',
        defaultHeight: 28,
        navbarHeight: 40,
        tabsHeight: 46,
        lineHeight: 1.5, //default line-Height
        containerIndentX: 16,
        componentFormIndent: 16,
    },
    typography: {
        fontFamily: 'Inter, Arial, Helvetica, sans-serif',
        fontSize: 12,
        heading: {
            fontSize: 14,
            fontWeight: 600,
            paddingBottom: '5px',
            letterSpacing: '0.12px',
            lineHeight: 1.21,
        },
        body1: {
            fontSize: 12,
            lineHeight: 1.5,
            letterSpacing: 'normal',
        },
        button: {
            fontWeight: 400,
            fontSize: 12,
            lineHeight: 1.5,
            letterSpacing: 'normal',
            textTransform: 'none',
        },
        label: {
            fontSize: 12,
            lineHeight: 1.5,
            letterSpacing: 'normal',
        },
        catalogMenu: {
            fontSize: 12,
            fontWeight: 400,
            fontStyle: 'normal',
            textTransform: 'none',
        },
        topBarMenu: {
            fontSize: 12,
            fontWeight: 400,
            fontStyle: 'normal',
            textTransform: 'none',
        },
    },
    zIndex: {
        mobileStepper: 1000,
        fab: 1050,
        speedDial: 1050,
        drawer: 1200,
        tabsPanel: 1250,
        modal: 1300,
        snackbar: 1400,
        tooltip: 1500,
        appBar: 1600,
    },
    //ToDo maybe use from default colors by default
    componentSettings: {
        catalog: {
            backgroundColor: MI_COLORS.white,
        },
        tile: {
            width: 184,
            height: 223,
            margin: 8,
            titleFontSize: 12,
            titleFontWeight: 600,
            titleColor: MI_COLORS.black,
            valueColor: MI_COLORS.black,
            secondaryTextColor: getBlendColors({} as any, alpha(MI_COLORS.black, 0.64), MI_COLORS.white),
            sectionTitleTextColor: MI_COLORS.blue,
            sectionTitleDividerColor: MI_COLORS.blue,
            headerBgColor: MI_COLORS.white,
            headerIconColor: getBlendColors({} as any, alpha(MI_COLORS.black, 0.64), MI_COLORS.white),
            favoriteIconColor: MI_COLORS.orange,
            bgColor: MI_COLORS.white,
            borderWidth: 1,
            borderRadius: 3,
            borderColor: getBlendColors({} as any, alpha(MI_COLORS.black, 0.24), MI_COLORS.white), //'#C9C9C9',
            hoverBorderColor: getBlendColors({} as any, alpha(MI_COLORS.black, 0.49), MI_COLORS.white), //'#929292',
            imagePosition: 'bottom',
            hoverShadow: '',
            shadow: '',
            stoplight: {
                goodColor: MI_COLORS.green,
                badColor: MI_COLORS.red,
                neutralColor: '#FFFFFF',
            },
        },
        tileList: {
            height: 75,
        },
        button: {
            backgroundColor: 3,
        },
        dropdown: {
            backgroundColor: MI_COLORS.white,
            borderColor: MI_COLORS.black, //review usage
            textColor: MI_COLORS.black,
            hoverOpacity: 80,
            borderRadius: 3,
        },
        primaryButton: {
            primaryColor: MI_COLORS.blue,
            textColor: '#fff',
        },
        topbar: {
            backgroundColor: MI_COLORS.blue,
            textColor: '#fff',
        },
        leftbar: {
            expandedBackgroundColor: MI_COLORS.white,
            expandedTextColor: MI_COLORS.black,
            collapsedBackgroundColor: MI_COLORS.white,
            collapsedTextColor: MI_COLORS.black,
        },
        tab: {
            primaryColor: MI_COLORS.blue,
        },
        highstockChart: {
            projection: '#6cb1ba',
            targetLine: '#000',
            defaultOverlay: '#00CCFF',
            annotation: MI_COLORS.blue,
            closedAlert: '#444444',
            movingAverage: 'rgb(124,0,0)',
            statistical: 'rgb(206, 160, 160)',
            statisticalFill: 'rgba(206, 160, 160, 0.4)',
            stoplightGrayAlpha: 'rgba(244, 224, 224, 1)',
            stoplightGreenAlpha: 'rgba(198, 224, 207, 1)',
            stoplightGray: 'rgb(244, 224, 224)',
            stoplightGreen: 'rgb(198, 224, 207)',
        },
        globalSearch: {
            activeFieldTextColor: MI_COLORS.black,
            backgroundColor: MI_COLORS.white,
        },
        sectionTitle: {
            textColor: MI_COLORS.blue,
            dividerColor: MI_COLORS.blue,
        },
    },
};
